<template>
  <form class="form-wrapper" autocomplete="off" @submit.prevent="submit">
    <div class="form-wrapper-body m-0">
      <div class="ActivityAftercareSetUpChildModalBody">
        <h3 class="ActivityAftercareSetUpChildModalBody-title">
          {{ activity.aftercareName }}
        </h3>


        <!-- <div class="ActivityAftercareSetUpChildModalBody-full">
          <p v-if="aftercareDay.status === 'Full'" class="ActivityAftercareSetUpChildModalBody-full-name">
            {{ aftercareDay.day | toCapitalize }}
          </p>
          <p
            v-if="aftercareDay.status === 'Full'"
            class="ActivityAftercareSetUpChildModalBody-full-description"
          >
            Activity Full
          </p>
        </div> -->

        <template
          v-if="(children && children.length) || (options && options.isSchool)"
        >
          <div class="mt-3 mb-2">
            <p class="ActivityAftercareSetUpChildModalBody-label">
              Select child
            </p>
            <select-box
              :data-list="children || []"
              :disabled="options && options.isSchool"
              :format-callback="
                (child) => `${child.firstName} ${child.lastName}`
              "
              :required="true"
              @selected="onChildSelect"
            />
          </div>

          <div v-if="isNewPaymentFlow" class="Filters--wrapper-days mt-3">
                <p class="ActivityAftercareSetUpChildModalBody-label mr-2">Select Days</p>
                <div class="Filters--wrapper-days-layout">
                    <div :class="['Filters--wrapper-days-layout-day', { 'day-selected': day.selected, 'day-disabled': day.disabled }]"
                         v-for="day of week"
                         @click="selectDay(day)"
                    >
                        {{ day.name.slice(0,3) }}
                    </div>
                </div>
        </div>

          <!--                    <template v-if="aftercareDay.status !== 'Full'">
                        <div class="d-flex flex-column mt-2">
                            <p class="ActivityAftercareSetUpChildModalBody-label">Select days</p>
                            <div class="ActivityAftercareSetUpChildModalBody-checkboxes">
                                <div v-for="(day,index) of week"
                                     :key="index">
                                    <label :class="['ActivityAftercareSetUpChildModalBody-checkboxes-checkbox', { 'disabled': day.disabled }]">
                                        <input type="checkbox"
                                               name="day"
                                               :checked="day"
                                               :value="day.id"
                                               :disabled="day.disabled"
                                               v-validate="{ 'required': aftercareDay.status !== 'Full' }"
                                               v-model="form.daysIds"
                                        />
                                        <span>{{ day.day.slice(0,3) | toCapitalize }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </template>-->

          <template
            v-if="childRosterInfo.addOns && childRosterInfo.addOns.length"
          >
            <div class="my-2">
              <p class="ActivityAftercareSetUpChildModalBody-label">
                Selected Add-ons
              </p>
              <div class="d-flex flex-wrap">
                <chip
                  v-for="addOn in childRosterInfo.addOns"
                  :key="addOn.id"
                  class="mx-1 my-1"
                  :style="{ backgroundColor: '#b496fa', color: '#ffffff' }"
                  :required-chip="true"
                  :label="addOn.name"
                  :width="140"
                >
                </chip>
              </div>
            </div>
          </template>

          <template v-if="activityAddOnsList && activityAddOnsList.length">
            <div class="my-2">
              <p class="ActivityAftercareSetUpChildModalBody-label">
                Select activity extras
              </p>
              <select-box
                :data-list="activityAddOnsList"
                :default-value="defaultValueAddOn"
                :required="false"
                :multiple-select="true"
                :format-callback="(addOn) => addOn.name"
                @selected="onActivityExtrasSelect"
              />
            </div>
          </template>

          <template
            v-if="
              (teachers &&
                teachers.length &&
                activitiesAftercareRequired &&
                activitiesAftercareRequired.teacher) ||
                (options &&
                  options.isSchool &&
                  activitiesAftercareRequired &&
                  activitiesAftercareRequired.teacher)
            "
          >
            <div class="my-2">
              <p class="ActivityAftercareSetUpChildModalBody-label">
                Who is your teacher
              </p>
              <select-box
                :data-list="teachers || []"
                :disabled="options && options.isSchool"
                :default-value="defaultTeacher"
                :required="
                  activitiesAftercareRequired &&
                    activitiesAftercareRequired.teacherRequired
                "
                :format-callback="(teacher) => teacher.name"
                @selected="onTeacherSelect"
              />
            </div>
          </template>

          <template
            v-if="
              (pickUps &&
                pickUps.length &&
                activitiesAftercareRequired &&
                activitiesAftercareRequired.pickUpOptions) ||
                (options &&
                  options.isSchool &&
                  activitiesAftercareRequired &&
                  activitiesAftercareRequired.pickUpOptions)
            "
          >
            <div class="my-2">
              <p class="ActivityAftercareSetUpChildModalBody-label">
                Pickup Options
              </p>
              <select-box
                :data-list="pickUps || []"
                :disabled="options && options.isSchool"
                :default-value="defaultPickUps"
                :required="
                  activitiesAftercareRequired &&
                    activitiesAftercareRequired.pickUpOptionsRequired
                "
                :format-callback="(pickUp) => pickUp.name"
                @selected="onPickUpSelect"
              />
            </div>
          </template>

          <template
            v-if="
              tShirtSizes &&
                tShirtSizes.length &&
                activitiesAftercareRequired &&
                activitiesAftercareRequired.tshirt
            "
          >
            <div class="mb-5">
              <p class="ActivityAftercareSetUpChildModalBody-label">
                T-Shirt size
              </p>
              <div class="d-flex align-items-center w-100 mb-4">
                <p class="w-25 text-gray mb-0">Young</p>
                <div
                  class="ActivityAftercareSetUpChildModalBody-checkboxes w-75"
                >
                  <div v-for="sizeYoung of sizesYoung" :key="sizeYoung.id">
                    <label
                      :class="[
                        'ActivityAftercareSetUpChildModalBody-checkboxes-checkbox',
                        { disabled: !sizeYoung.status },
                      ]"
                    >
                      <input
                        type="radio"
                        name="tShirt"
                        :id="sizeYoung.id"
                        :value="sizeYoung.id"
                        :checked="sizeYoung.id == form.tshirtSizeId"
                        :disabled="!sizeYoung.status"
                        @change="form.tshirtSizeId = $event.target.value"
                      />
                      <span>{{ sizeYoung.size.substring(1) }}</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center w-100">
                <p class="w-25 text-gray mb-0">Adult</p>
                <div
                  class="ActivityAftercareSetUpChildModalBody-checkboxes w-75"
                >
                  <div v-for="sizeAdult of sizesAdult" :key="sizeAdult.id">
                    <label
                      :class="[
                        'ActivityAftercareSetUpChildModalBody-checkboxes-checkbox',
                        { disabled: !sizeAdult.status },
                      ]"
                    >
                      <input
                        type="radio"
                        name="tShirt"
                        :id="sizeAdult.id"
                        :value="sizeAdult.id"
                        :checked="sizeAdult.id == form.tshirtSizeId"
                        :disabled="!sizeAdult.status"
                        @change="form.tshirtSizeId = $event.target.value"
                      />
                      <span> {{ sizeAdult.size }}</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="error mt-3">{{ errors.first("tShirt") }}</div>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="not-found m-0 text-center" :style="{ height: '85%' }">
            <img
              src="../../assets/img/background.png"
              :style="{
                width: '280px',
                height: '200px',
                'margin-bottom': '25px',
              }"
            />
            Oh no! First add child, please.
          </div>
        </template>
      </div>
    </div>

    <div class="form-wrapper-footer d-flex justify-content-between"
      :key="formsButtonUpdate">
      <div
        v-if="activity.price === 0"
        class="ActivityClassSetUpChildModalBottom text-green"
      >
        FREE
      </div>
      <div v-else class="d-flex flex-column">
        <span
          v-if="options && options.isSchool"
          class="ActivityClassSetUpChildModalBottom"
          >{{ activity.price.toFixed(2) }}</span
        >
        <span v-else class="ActivityClassSetUpChildModalBottom">
          {{ schoolInfo.currency | currencySign }} {{ activity.price.toFixed(2) }}</span
        >
        <span :style="{ color: '#0d0d25' }">
          {{ activity.billingRate | toCapitalize }}
        </span>
      </div>
        <button
          v-if="activityForms.length === 0"
          :class="[
            'form-wrapper-footer-button',
            'primary-btn',
            aftercareDay.status === 'Full' &&
              'form-wrapper-footer-button-waitlist',
            isLoading && 'ie-spinner',
          ]"
          :style="{ width: '150px' }"
          :disabled="disabledButton"
          type="submit"
          v-spinner="isLoading"
        >
          <template v-if="aftercareDay.status === 'Online'">{{ isNewPaymentFlow ? 'Pay Now' : 'Add to Cart' }}</template>
          <template v-else-if="aftercareDay.status === 'Full'"
            >Add to Waitlist</template>
        </button>
        <button 
            v-else
            :class="[
                'primary-btn',
            ]"
            :style="{ width: '150px' }"
            :disabled="disabledButton"
            v-spinner="isLoading"
            @click.prevent="goToCustomForms"
            >
            Continue
        </button>
    </div>
  </form>
</template>

<script>
import * as _ from "lodash";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as types from "@/store/mutationTypes";
import { DAYS } from "@/constants/dates";
import { FormMixin } from "@/mixins/FormMixin";
import { GetUserInfoFromLocalStorage } from "@/mixins/GetUserInfoFromLocalStorage";
import { eventBus } from '@/main';

const CustomFormModal = () => import(/* webpackChunkName: "activities" */ '@/components/modals/CustomFormModal');

export default {
  name: "ActivityAftercareSetUpChildModal",

  components: {
    Chip: () => import("@/components/controls/Chip"),
    SelectBox: () => import("@/components/controls/SelectBox"),
    CustomForm: () => import("@/components/modals/CustomForm/CustomForm.vue"),
  },

  data() {
    return {
      showForm: false,
      sizesAdult: [],
      sizesYoung: [],
      form: {
        childId: null,
        teacherId: null,
        pickUpOptionId: null,
        addOnIds: [],
        tshirtSizeId: null,
      },
      formsButtonUpdate: 0,
      week: DAYS.map(el => {
                    return {
                        name: el,
                        selected: false,
                        disabled: true
                    }
                }),
    };
  },

  computed: {
    ...mapGetters([
      "isLoading",
      "schoolInfo",
      "children",
      "teachers",
      "pickUps",
      "tShirtSizes",
      "activity",
      "aftercareDay",
      "childRosterInfo",
      "activityExtrasAftercare",
      "activitiesAftercareRequired",
      "options",
      "customForms",
      'activityForms',
      'activitiesAftercareRostersFreeDays',
      'activitiesAftercareWaitlistFreeDays'
    ]),

    isNewPaymentFlow() {
        return this.schoolInfo && this.schoolInfo.schoolFeatures && this.schoolInfo.schoolFeatures['new-payments'];
    },
    isButtonDisabled() {
        if(this.isNewPaymentFlow) {
          if (this.aftercareDay.status === "Online") {
            return this.activitiesAftercareRostersFreeDays.length === 0;
          } else {
            return this.activitiesAftercareWaitlistFreeDays.length === 0;
          }
        } else {
          return false
        }
    },
    isNoDaysSelected() {
      if (this.isNewPaymentFlow) {
        return !this.week.some(day => day.selected && !day.disabled);
      } else {
        return false;
      }
    },

    disabledButton() {
      return (
        !this.formValid ||
        this.formPristine ||
        this.isLoading ||
        this.isNoDaysSelected ||
        this.isButtonDisabled ||
        (this.activitiesAftercareRequired &&
          this.activitiesAftercareRequired.tshirtRequired &&
          !this.form.tshirtSizeId) ||
        (this.options && this.options.isSchool)
      );
    },

    activityAddOnsList() {
      if (this.childRosterInfo.addOns && this.childRosterInfo.addOns.length) {
        this.activityExtrasAftercare &&
          this.childRosterInfo.addOns.forEach((item) =>
            this.activityExtrasAftercare.forEach(
              (el, index) =>
                el.id === item.id &&
                this.activityExtrasAftercare.splice(index, 1)
            )
          );

        return this.activityExtrasAftercare;
      } else {
        return this.activityExtrasAftercare;
      }
    },

    defaultValueAddOn() {
      return (
        this.activityAddOnsList &&
        this.activityAddOnsList.length &&
        this.activityAddOnsList.filter((addOn) => addOn.required)
      );
    },

    defaultTeacher() {
      if (this.childRosterInfo && this.childRosterInfo.teacherId) {
        const teacher =
          this.childRosterInfo &&
          this.teachers.find(
            (teacher) => teacher.id === this.childRosterInfo.teacherId
          );
        return teacher;
      } else {
        return null;
      }
    },

    defaultPickUps() {
      if (this.childRosterInfo && this.childRosterInfo.pickUpOptionId) {
        const pickUpOption =
          this.childRosterInfo &&
          this.pickUps.find(
            (pickUpOption) =>
              pickUpOption.id === this.childRosterInfo.pickUpOptionId
          );
        return pickUpOption;
      } else {
        return null;
      }
    },
    /*            week() {
                let week = [];
                const sorterByDay = {
                    "sunday": 0,
                    "monday": 1,
                    "tuesday": 2,
                    "wednesday": 3,
                    "thursday": 4,
                    "friday": 5,
                    "saturday": 6
                };

                for (const item of this.activity.days) {
                    week.push({
                        id: item.id,
                        day: item.day.toLowerCase(),
                        disabled: item.status === 'Full' || item.status === 'Closed',
                    })
                }

                DAYS.forEach(el => {
                    let baseWeek = [];
                    week.forEach(obj => baseWeek.push(obj.day));

                    if (!baseWeek.includes(el.toLowerCase())) {
                        week.push({
                            id: null,
                            day: el.toLowerCase(),
                            disabled: true
                        })
                    }
                });

                return week.sort((first, second) => sorterByDay[first.day.toLowerCase()] - sorterByDay[second.day.toLowerCase()]);
            }*/
  },

  mixins: [GetUserInfoFromLocalStorage, FormMixin],

  methods: {
    ...mapActions([
      "showSpinner",
      "closeModal",
      "getChildren",
      "getTeachers",
      "getTShirtSizes",
      "getPickUpOptions",
      "getActivityExtrasAftercare",
      "getChildInfoForEnroll",
      "getAftercareRequired",
      "addToCartAftercare",
      "addToWaitListAftercare",
      'openModal',
      'sendCustomForms',
      'getNotFilledCustomForms',
      'checkChildBeforeAftercareEnroll',
      'getRostersFreeDays',
      'getWaitlistFreeDays'
    ]),

    ...mapMutations({
      setActivityExtras: types.SET_ACTIVITY_EXTRAS_AFTERCARE,
      setActivityChildRosterInfo: types.SET_ACTIVITY_CHILD_ROSTER_INFO,
      setActivityRequired: types.SET_ACTIVITIES_AFTERCARE_REQUIRED,
      cleanCustomForms: types.CLEAN_CUSTOM_FORM,
      cleanActivityForms: types.CLEAN_ACTIVITY_FORMS
    }),

    async onChildSelect(child) { 
      if (child) {
        this.$emit('removeModal', 'CustomFormModal');
        this.cleanCustomForms();
        this.form.childId = child.id;
        await this.setActivityExtras(null);
        await this.setActivityChildRosterInfo(null);
        if (this.activity.forms.length !== 0) {
          await this.getNotFilledCustomForms({
              activityType: 'Aftercare',
              activityId: this.activity.id,
              formIds: this.activity.forms.map(el => el.id),
              childId: child.id
          });
        }
        this.formsButtonUpdate += 1;

        const promisesArray = [
          this.getActivityExtrasAftercare(this.activity.id),
          this.getChildInfoForEnroll({
            aftercareId: this.activity.id,
            childId: child.id,
          }),
        ]

        if (this.isNewPaymentFlow) {
          if (this.aftercareDay.status === "Online") {
          promisesArray.push(
            this.getRostersFreeDays({
            schoolId: this.schoolInfo.id,
            aftercareId: this.activity.id,
            childId: child.id,
            aftercareDayId: this.aftercareDay.id,
            status: this.aftercareDay.status
          }));
        } else {
          promisesArray.push(
            this.getWaitlistFreeDays({
            schoolId: this.schoolInfo.id,
            aftercareId: this.activity.id,
            childId: child.id,
            aftercareDayId: this.aftercareDay.id,
          }));
        }    
        }

        await Promise.all(promisesArray).then(() =>  {
          this.defaultTShirtSize();
          if (this.isNewPaymentFlow) {
            if (this.aftercareDay.status === "Online") {
              this.week = this.setAvaiableDays(this.week, this.activitiesAftercareRostersFreeDays, this.aftercareDay);
            } else {    
              this.week = this.setAvaiableDays(this.week, this.activitiesAftercareWaitlistFreeDays, this.aftercareDay);
              
            }
          }
        });
      }
    },

    defaultTShirtSize() {
      if (this.childRosterInfo && this.childRosterInfo.tshirtSizeId) {
        this.form.tshirtSizeId = this.tShirtSizes.find(
          (tShirt) => tShirt.id === this.childRosterInfo.tshirtSizeId
        ).id;
        this.formCopy.tshirtSizeId = this.form.tshirtSizeId;
      }
    },

    onTeacherSelect(teacher) {
      if (teacher) {
        this.form.teacherId = teacher.id;
      } else {
        this.form.teacherId = "";
      }
    },

    onPickUpSelect(pickUp) {
      if (pickUp) {
        this.form.pickUpOptionId = pickUp.id;
      } else {
        this.form.pickUpOptionId = "";
      }
    },

    onActivityExtrasSelect(addOns) {
      if (addOns) {
        addOns.length
          ? (this.form.addOnIds = addOns.map((addOn) => addOn.id))
          : (this.form.addOnIds = []);
      }
    },

    setSizes() {
      _.forEach(this.tShirtSizes, (obj) => {
        obj.size.search("Y")
          ? this.sizesAdult.push(obj)
          : this.sizesYoung.push(obj);
      });
    },

    async goToCustomForms() {
      try {
        this.showSpinner(true);
        await this.checkChildBeforeAftercareEnroll({
          aftercareId: this.activity.id, 
          childId: this.form.childId,
          aftercareDayId: this.aftercareDay.id
        });
      } finally {
        this.showSpinner(false);
      }
      if (this.activityForms.length) {
        this.openModal({
        modal: CustomFormModal,
        options: {
          customForms: this.activityForms,
          modalType: 0,
          childId: this.form.childId,
          activityId: this.activity.id,
          activityType: 'Aftercare',
          activityStatus: this.aftercareDay.status
        }
        });
      }
    },

    selectDay(day) {
                if (day.disabled) return;

                day.selected = !day.selected;

                for (const key in this.filters) {
                    if (_.lowerCase(day.name) === key) {
                        this.filters[key] = day.selected;
                        this.updateFilterDay(this.filters);
                    }
                }
    },

    async submit() {
      const valid = await this.$validator.validateAll();

      if (!valid) return;

      try {
        this.showSpinner(true);

        // if custom form was added
        if(this.activityForms.length) {
          await this.sendCustomForms({
            forms: this.customForms,
            parentId: this.UserInfo.userId
          });
        }
        this.activityAddOnsList &&
          !this.activityAddOnsList.length &&
          (this.form.addOnIds = []);

        let aftercareDayIds;
        
        if (this.isNewPaymentFlow) {
          if (this.aftercareDay.status === 'Online') {
            aftercareDayIds = this.activitiesAftercareRostersFreeDays.filter(day => this.week.find(el => el.name.toLowerCase() === day.day.toLowerCase()).selected).map(day => day.id);
          } else {
            aftercareDayIds = this.activitiesAftercareWaitlistFreeDays.filter(day => this.week.find(el => el.name.toLowerCase() === day.day.toLowerCase()).selected).map(day => day.id);
          }
        } else {
          aftercareDayIds = [this.aftercareDay.id];
        }

        this.aftercareDay.status === "Online"
          ? await this.addToCartAftercare({
              form: {
                ...this.form,
                aftercareDayIds: aftercareDayIds,
                aftercareId: this.activity.id,
              },
              aftercareId: this.activity.id,
              enrollTo: "Rosters",
            })
          : await this.addToWaitListAftercare({
              form: {
                ...this.form,
                aftercareDayIds: aftercareDayIds,
                aftercareId: this.activity.id,
              },
              aftercareId: this.activity.id,
            });

        this.closeModal();
      } finally {
        this.showSpinner(false);
      }
    },

    setAvaiableDays(week, backendDays, aftercareDay) {

      
  // Normalize backend days to lowercase for comparison
  const backendDaySet = new Set(backendDays.map(day => day.day.toLowerCase()));

  return week.map(day => {
    const dayNameLower = day.name.toLowerCase();

    // If the day is in the backend list, enable it (disabled = false)
    const isInBackend = backendDaySet.has(dayNameLower);

    return {
      ...day,
      disabled: !isInBackend, // disable the day if not in backend list
      selected: dayNameLower === aftercareDay.day.toLowerCase() // select the matching aftercareDay
    };
  });
    }
  },
  

  async beforeMount() {
    eventBus.$on('submitCustomForms', this.submit);
    this.getAftercareRequired(this.activity.id);
    this.options &&
      !this.options.isSchool &&
      this.getChildren(this.UserInfo.userId);
    await this.getTShirtSizes();
    this.options && !this.options.isSchool && this.getPickUpOptions();
    this.options && !this.options.isSchool && this.getTeachers();
    this.setSizes();
  },

  beforeDestroy() {
    eventBus.$off('submitCustomForms', this.submit);
    this.form = null;
    this.setActivityExtras(null);
    this.setActivityRequired(null);
    this.setActivityChildRosterInfo(null);
    this.cleanCustomForms();
    this.cleanActivityForms();
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";

.ActivityAftercareSetUpChildModalBody {
  height: 100%;
  margin: 0 30px;

  &-title {
    margin-bottom: 12px;
    text-align: left;
    word-break: break-word;
    font-size: 28px;
    font-weight: 700;
    color: $Dark;
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      //for IE
      word-break: break-all;
    }
  }

  &-label {
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 700;
  }

  &-full {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-weight: 700;

    &-name {
      font-size: 16px;
      color: $Copyright;
      word-break: break-word;
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        //for IE
        word-break: break-all;
      }
    }

    &-description {
      font-size: 14px;
      color: $SimplyAfterSchoolRed;
    }
  }

  &-checkboxes {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    &-checkbox {
      position: relative;
      width: 35px;
      height: 35px;
      margin: 5px 0;
      border-radius: 2px;
      cursor: pointer;
      background-color: $ComplementaryBgTxtDarker;

      input {
        position: absolute;
        height: 0;
        width: 0;
        display: none;
        cursor: pointer;

        &:checked ~ span {
          border-radius: 2px;
          color: $White;
          background-color: $Violet;
        }
      }

      span {
        position: absolute;
        top: 0;
        left: 0;
        width: 35px;
        height: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 11px;
        font-weight: 500;
        color: $Dark;
      }
    }

    .disabled {
      opacity: 0.4;
      cursor: no-drop;
    }
  }
}

.customForm--container {
  display: flex;
  flex-direction: column;
  justify-content: center;

  & .customForm--button {
    margin: auto;
    border-radius: 24.5px;
    font-weight: 500;
    height: 49px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      cursor: pointer;
    }
  }
}

.ActivityClassSetUpChildModalBottom {
  font-size: 24px;
  font-weight: 700;
  color: $SoftBlue;
}

.Filters {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: 30px;

        &--wrapper {
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            &-days {
                display: flex;
                align-items: center;
                flex-wrap: wrap;

                &-layout {
                    display: flex;
                    justify-content: space-between;

                    &-day {
                        height: 37px;
                        width: 100%;
                        min-width: 37px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-right: 10px;
                        border-radius: 2px;
                        cursor: pointer;
                        font-size: 11px;
                        color: $ShoppingCartTextColor;
                        background-color: $ComplementaryBgTxtDarker;

                        @media screen and (max-width: 900px) {
                            height: 35px;
                            width: 35px;
                        }

                        @media screen and (max-width: 425px) {
                            height: 35px;
                            width: 35px;
                            margin-top: 5px;
                            margin-right: 9px;
                        }
                    }

                    .day-selected {
                        color: $White;
                        background-color: $Violet;

                        @media screen and (max-width: 900px) {
                            justify-content: center;
                        }
                    }

                    .day-disabled {
                        cursor: not-allowed;
                        opacity: 0.5;
                    }
                }
            }
        }

        &--btn {
            height: 40px;
            max-width: 10%;
            min-width: 100px;
            background-color: #f7f8f9;

            @media screen and (max-width: 900px) {
                max-width: 20%;
            }

            @media screen and (max-width: 768px) {
                max-width: 30%;
            }

            @media screen and (max-width: 425px) {
                max-width: 40%;
            }
        }
    }

    /deep/ .form-group {
        margin-bottom: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/modals/ActivityAftercareSetUpChildModal.vue